// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2Uq6A","checkboxCol":"Table_checkboxCol__1tS_H","emailCol":"Table_emailCol__12fTk","actionCol":"Table_actionCol__266ua"};